const gigya = window.gigya

export default gigya
